/**
 * Abbonamenti: la rotta resta /services perche' i segnalibri vecchi devono
 * continuare a funzionare; a cambiare e' il nome che si legge, non l'indirizzo.
 *
 * Sul computer la pagina e' AbbonamentiDesktop (ridisegnata il 26/10/2026:
 * prodotti coi loghi, rinnovi, cose da sistemare, elenco, canoni a mano in una
 * pagina sola). Sul telefono resta AbbonamentiMobile.
 */
import { useIsMobile } from '../../hooks/useIsMobile';
import { AbbonamentiMobile } from './AbbonamentiMobile';
import { AbbonamentiDesktop } from './AbbonamentiDesktop';

export function ServicesPage() {
  const isMobile = useIsMobile();
  return isMobile ? <div className="page"><AbbonamentiMobile /></div> : <AbbonamentiDesktop />;
}
